export const unknownSenderOrRecipient = "Fe_HIe";
export default {unknownSenderOrRecipient};